import { authHeader, handleResponse } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFuseDetails(fuseId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/fuses/${fuseId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function editFuseDetailService(fuseId, formData) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(formData),
  };

  const endPoint = `/api/admin/v1/fuses/${fuseId}`;
  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createFuse(requestBody) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };

  const endPoint = `/api/admin/v1/fuses`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getCountryList() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/configurations/countries`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFuseKPIDetails(serialNumber) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/fuses/${serialNumber}/kpis/latest`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const fuseDetailService = {
  getFuseDetails,
  editFuseDetailService,
  createFuse,
  getCountryList,
  getFuseKPIDetails,
};
